import constants from './constants';
import util from "./util"
import {saveAs} from 'file-saver';
import './adapter';

var new_webrtc = function () {
    var PeerConnection = (window.PeerConnection || window.webkitPeerConnection || window.webkitRTCPeerConnection || window.mozRTCPeerConnection);
    var URL = (window.URL || window.webkitURL || window.msURL || window.oURL);
    var getUserMedia = (navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia);
    var nativeRTCIceCandidate = (window.RTCIceCandidate);
    var nativeRTCSessionDescription = (window.mozRTCSessionDescription || window.RTCSessionDescription); // order is very important: "RTCSessionDescription" defined in Nighly but useless
    var iceServer = {
        "iceServers": [
            {
                "url": "stun:stun.l.google.com:19302"
            },
            {
                "url": "stun:www.diantiyun.com:3478"
            },
            {
                "url": "turn:www.diantiyun.com:3478",
                "username": "sylg",
                "credential": "55633d357661e032fd954a74858d44b3"
            },
        ]
    };
    var packetSize = 1000;

    /**********************************************************/
    /*                       事件处理器                       */

    /**********************************************************/
    function EventEmitter() {
        this.events = {};
    }

    //绑定事件函数
    EventEmitter.prototype.on = function (eventName, callback) {
        this.events[eventName] = this.events[eventName] || [];
        this.events[eventName].push(callback);
    };
    //触发事件函数
    EventEmitter.prototype.emit = function (eventName, _) {
        var events = this.events[eventName],
            args = Array.prototype.slice.call(arguments, 1),
            i, m;
        if (!events) {
            return;
        }
        for (i = 0, m = events.length; i < m; i++) {
            events[i].apply(null, args);
        }
    };


    /**********************************************************/
    /*                   流及信道建立部分                       */

    /**********************************************************/


    /*******************基础部分*********************/
    function new_webrtc() {
        //本地media stream
        this.localMediaStream = null;
        //所在房间
        this.room = [];
        //接收文件时用于暂存接收文件
        this.fileData = {};
        //本地WebSocket连接
        this.socket = null;
        //本地socket的id，由后台服务器创建
        this.me = null;
        //保存所有与本地相连的peer connection， 键为socket id，值为PeerConnection类型
        this.peerConnections = {};
        //保存所有与本地连接的socket的id
        this.connections = [];
        //保存所有与本地连接的socketId的id~remote 对应的uid 的映射
        this.connectionMap = {};
        //初始时需要构建链接的数目
        this.numStreams = 0;
        //初始时已经连接的数目
        this.initializedStreams = 0;
        //保存所有的data channel，键为socket id，值通过PeerConnection实例的createChannel创建
        this.dataChannels = {};
        //保存所有发文件的data channel及其发文件状态
        this.fileChannels = {};
        //保存所有接受到的文件  sendId
        this.receiveFiles = {};
        //request 的回调函数们
        this.channelRequestCallbacks = {};
        //request 的倒计时
        this.channelRequestTimers = {};
        //    单个文件下载完成
        this.fileFinish = 0;
        this.__id = Math.random().toFixed(5);
        this.initEvents();
        this.number = 0;
        // this.isMonitor = false;
        this.action = '';
        this.orientationMap = {};
    }

    //继承自事件处理器，提供绑定事件和触发事件的功能
    new_webrtc.prototype = new EventEmitter();
    /*************************服务器连接部分***************************/

    new_webrtc.prototype.joinRoom = function (roomId) {
        this.socket.send(JSON.stringify({
            "eventName": "__join",
            "data": {
                "room": roomId,
                "uid": constants.uid
            }
        }));
    }
    //本地连接信道，信道为websocket
    new_webrtc.prototype.connect = function (data) {
        var socket, server = data.server, room = data.room || "", action = data.action, that = this;
        // this.isMonitor = data.isMonitor;
        this.action = action;
        this.room.push(room);
        socket = this.socket = new WebSocket(server);
        //连接成功后发送  房间号
        socket.onopen = function () {
            // setTimeout(()=>{
                that.joinRoom(room);
            // },2000)
            that.emit("socket_opened", socket);
        };
        socket.onmessage = function (message) {
            var json = JSON.parse(message.data);
            if (json.eventName) {
                that.emit(json.eventName, json.data);
            } else {
                that.emit("socket_receive_message", socket, json);
            }
        };
        socket.onerror = function (error) {
            that.emit("socket_error", error, socket);
        };
        socket.onclose = function (data) {
            console.log("socket.onclose===> ")
            that.ready = false;
            if (that.localMediaStream) {
                that.localMediaStream.getTracks().forEach(track => {
                    track.stop();
                    that.localMediaStream.removeTrack(track);
                })
            }
            var pcs = that.peerConnections;
            util.context.$store.commit("changeDownloadState", false);
            for (let i in pcs) {
                that.closePeerConnection(pcs[i])
                that.emit("remove_peer", i)
            }
            that.peerConnections = [];
            that.dataChannels = {};
            that.connectionMap = {};
            that.fileChannels = {};
            that.connections = [];
            that.fileData = {};
            that.room = []
            that.emit('socket_closed', socket);
        };

    };
    new_webrtc.prototype.getRotate = function (stream, orientation) {
        let sizeChange = orientation % 90 !== 0;
        if (orientation % 360 === 0) return stream;
        let settings = {
            width: Math.abs(window.orientation % 180) ? 420 : 600,
            height: Math.abs(window.orientation % 180) ? 600 : 420
        }
        let audioTracks = stream.getAudioTracks();
        var video = document.createElement('video');
        try {
            video.srcObject = stream;
        } catch (error) {
            video.src = URL.createObjectURL(stream);
        }
        video.play();
        var canvas = document.createElement('canvas');
        canvas.width = sizeChange ? settings.width : settings.height; // 400
        canvas.height = sizeChange ? settings.height : settings.width; // 600
        var ctx = canvas.getContext('2d')
        ctx.translate(canvas.width / 2, canvas.height / 2); // 200,300
        ctx.rotate(orientation * Math.PI / 180)
        ctx.translate(-canvas.width / 2, -canvas.height / 2);
        var newStream = new MediaStream();
        var capturedStream;
        if ('captureStream' in canvas) {
            capturedStream = canvas.captureStream();
        } else if ('mozCaptureStream' in canvas) {
            capturedStream = canvas.mozCaptureStream();
        }
        if (capturedStream) {
            setInterval(() => {
                ctx.drawImage(video, (canvas.width - settings.width) / 2, (canvas.height - settings.height) / 2, settings.width, settings.height);
            }, 40);
            capturedStream.getVideoTracks().forEach(vt => newStream.addTrack(vt));
            audioTracks.forEach(at => newStream.addTrack(at));
            return newStream;
        } else {
            return stream;
        }
    }
    new_webrtc.prototype.initEvents = function () {
        var that = this
        // 第一次发起  房间无人
        this.on('_peers', function (data) {
            console.log("==== 收到_peers  data :: ",data);
            var map = {};
            data.connections.forEach((socketId, index) => {
                map[socketId] = decodeURI(data.connections_uids[index]);
            })
            constants.tempConnections = map;
            that.me = data.you;

            that.emit('connected', that.socket, that.action);
            if (util.page_monitor) util.page_monitor.isTerminalJoin = false
        });
        //添加对方将信息
        this.on("_ice_candidate", function (data) {
            console.log(" ================ 触发 _ice_candidate  start ====", data);
            data.sdpMid = data.id;
            data.sdpMLineIndex = data.label;
            var candidate = new nativeRTCIceCandidate(data);
            var pc = that.peerConnections[data.socketId];
            // if (!pc || !pc.remoteDescription.type) {}
            if(pc){
                pc.addIceCandidate(candidate);
            }
            console.log(" ================ 触发 _ice_candidate  end ====");
            that.emit('get_ice_candidate', candidate);
        });
        //服务端  新连接进入 增一个peer
        this.on('_new_peer', function (data) {
            // console.log('new peer ===>', data)
            that.connections.push(data.socketId);
            that.connectionMap[data.socketId] = decodeURI(data.uid);
            var pc = that.createPeerConnection(data.socketId),
                i, m;
            if (that.localMediaStream != null) pc.addStream(that.localMediaStream);
            that.emit('new_peer', data.socketId);
            if (util.page_monitor) util.page_monitor.isTerminalJoin = false
        });
        //  移除 连接
        this.on('_remove_peer', function (data) {
            var sendId;
            that.closePeerConnection(that.peerConnections[data.socketId]);
            delete that.peerConnections[data.socketId];
            delete that.dataChannels[data.socketId];
            // delete that.connectionMap[data.socketId];
            for (sendId in that.fileChannels[data.socketId]) {
                that.emit("send_file_error", new Error("Connection has been closed"), data.socketId, sendId, that.fileChannels[data.socketId][sendId].file);
            }
            delete that.fileChannels[data.socketId];
            that.emit("remove_peer", data.socketId);
        });
        // 发送 指令
        this.on('_offer', function (data) {
            console.log("   ===== 触发接收_offer，发送answer ======  ");
            that.receiveOffer(data.socketId, data.sdp);
            that.emit("get_offer", data);
        });
        //  接受回应
        this.on('_answer', function (data) {
            that.receiveAnswer(data.socketId, data.sdp);
            that.emit('get_answer', data);
        });

        this.on('_stream_orientation', function (data) {
            console.log("======= 触发_stream_orientation start", data);
            let socketId = data.socketId;
            var videoTag = document.getElementById("video-cell-" + socketId);
            if (videoTag) {
                if (data.orientation) {
                    let stream = that.getRotate(videoTag.stream, data.orientation);
                    that.attachStream(stream, videoTag);
                }
                // videoTag.style.transform = 'rotateZ('+data.orientation+'deg)';
            } else that.orientationMap[socketId] = data.orientation;
        })
        this.on('_keep_live', function (data) {
            that.socket.send(JSON.stringify({
                eventName: '__alive'
            }))
        })
        this.on('send_file_error', function (error, socketId, sendId, file) {
            that.cleanSendFile(sendId, socketId);
        });

        this.on('receive_file_error', function (error, sendId) {
            that.cleanReceiveFile(sendId);
        });
        this.on("ready", function () {
            console.log("===== 触发ready start =====");
            if (!that.ready) {
                that.createPeerConnections();
                console.log(" 当前本地视频流对象 ：：  ",that.localMediaStream);
                if (that.localMediaStream) that.addStreams();
                that.sendOffers();
                that.addDataChannels();

            }
            console.log("===== 触发ready end =====");
            that.ready = true;
        });
        this.on("connected", function (socket, action) {
            console.log("===== 触发connected start =====");
            console.log(socket, action);
            that.createStream({
                "video": true,
                "audio": false
            }, action);
            console.log("===== 触发connected end =====");
        });
//创建本地视频流成功
        this.on("stream_created", function (stream) {
            console.log("===== 触发stream_created start =====");
            if (document.getElementById('me')) {

                // 2025年7月2日  王欢 取消加载loading
                if (util.context.$route.name === 'page_lift_monitor') {
                    util.context.videoShowLoading = false;
                }

                document.getElementById('me').srcObject = stream;
                document.getElementById('me').play();
            }
        });
//创建本地视频流失败
        this.on("stream_create_error", function () {
            alert("创建视频流失败!");
        });

//删除其他用户  移除其他DOM结构
        this.on('remove_peer', function (socketId) {
            console.log("remove_peer====>")
            var videos = document.getElementById("videos");
            var ifMobile = that.connectionMap[socketId].split("|")[0].indexOf("terminal_T") < 0;
            var videoCell = document.getElementById("video-cell-" + socketId);
            var videoRoom = document.getElementById("video-room-" + socketId);
            if (videoCell) videoCell.parentNode.removeChild(videoCell);
            if (videoRoom) videoRoom.parentNode.removeChild(videoRoom);
            if (videoCell) util.initVideoPageSize(util.context.$store.state.app.isCallHelp, socketId, ifMobile);
        });
//接收到文字信息
        this.on('data_channel_message', function (channel, socketId, message) {
        });

        //接收到其他用户的视频流
        this.on('pc_add_stream', function (stream, socketId, pc) {
            console.log(" ============== 触发pc_add_stream ========");
            var videos;
            var ifMobile = that.connectionMap[socketId].split("|")[0].indexOf("terminal_T") < 0;
            // console.log("是否是手机端进入==== > "+ifMobile)
            if (!ifMobile) {
                let orientation = that.orientationMap[socketId];
                if (util.context.$store.state.app.isCallHelp) {
                    videos = document.getElementById("save-videos");
                } else {
                    videos = document.getElementById("videos");
                }
                var id = "other-" + socketId;
                var videoCell = document.createElement("div");
                videoCell.setAttribute("class", "video-cell");
                videoCell.setAttribute("id", "video-cell-" + socketId);
                if (orientation) {
                    stream = that.getRotate(stream, orientation);
                }
                // videoCell.setAttribute("style","transform:rotateZ("+orientation+"deg)");
                var videoTag = document.createElement("video");
                videoTag.setAttribute("class", "other-video");
                videoTag.setAttribute("object-fit", "fill")
                videoTag.setAttribute("autoplay", "autoplay");
                videoTag.setAttribute("id", id);
                videoCell.appendChild(videoTag);
                videoTag.stream = stream;
                var videoRoom = document.createElement("div");
                videoRoom.setAttribute("class", "video-room");
                videoRoom.setAttribute("id", "video-room-" + socketId);
                if (!util.context.$store.state.app.isCallHelp) videoRoom.setAttribute("style", "color:#fff");
                videoRoom.innerText = that.connectionMap[socketId].split("|")[1];
                if (util.context.$store.state.app.isCallHelp) videoCell.appendChild(videoRoom)
                if (videos) {
                    videos.appendChild(videoCell);
                    if (!util.context.$store.state.app.isCallHelp) videos.appendChild(videoRoom)
                }
                that.attachStream(stream, videoTag);
                // if (util.context.$store.state.app.isCallHelp&&!ifMobile) videoRoom.setAttribute("style","transform:rotate(-180deg)")
                util.initVideoPageSize(util.context.$store.state.app.isCallHelp, socketId, ifMobile);
                if (that.orientationMap[socketId] && videoTag) {
                    delete that.orientationMap[socketId];
                }
            }
        });
    }

    /*************************流处理部分*******************************/


    //创建本地流
    new_webrtc.prototype.createStream = function (options, action) {
        console.log("===== 触发createStream start =====");
        if (action == 'monitor') { // 只有监控的时候走这个，
            this.emit("ready");
            return;
        } else if (action == 'help') {
            var that = this;
            options = {
                video: {
                    displaySurface: 'monitor'
                },
                audio: true
            }
            if (getUserMedia) {
                this.numStreams++;
                getUserMedia.call(navigator, options, function (stream) {
                        that.localMediaStream = stream;
                        that.initializedStreams++;
                        that.emit("stream_created", stream);
                        if (that.initializedStreams === that.numStreams) {
                            that.emit("ready");
                        }
                    },
                    function (error) {
                        that.emit("stream_create_error", error);
                    });
            } else {
                // navigator.mediaDevices.getUserMedia(options).then(function(mediaStream) {
                //     that.localMediaStream = mediaStream;
                //     that.initializedStreams ++;
                //     that.emit("stream_created", mediaStream);
                //     if (that.initializedStreams === that.numStreams) {
                //         that.emit("ready");
                //     }
                // }).catch(function(err) {
                that.emit("stream_create_error", new Error('当前浏览器不支持WebRTC'));
                // console.log(err.name + ": " + err.message);
                // });
            }
        }

        console.log("===== 触发createStream end =====");
    };

    //将本地流添加到所有的PeerConnection实例中,  为了让别人看见我
    new_webrtc.prototype.addStreams = function () {
        var i, m,
            stream,
            connection;
        for (connection in this.peerConnections) {
            this.peerConnections[connection].addStream(this.localMediaStream);
        }
    };

    //将流绑定到video标签上用于输出
    new_webrtc.prototype.attachStream = function (stream, element) {
        console.log(" ====== 触发attachStream ======= ");
        try {
            element.srcObject = stream;
        } catch (error) {
            element.src = URL.createObjectURL(stream);
        }
    };

    /***********************信令交换部分*******************************/

    //向所有PeerConnection发送Offer类型信令
    new_webrtc.prototype.sendOffers = function () {
        console.log("  触发sendOffers  ==========  ");
        var i, m, pc, that = this,
            pcCreateOfferCbGen = function (pc, socketId) {
                return function (session_desc) {
                    console.log("  当前 sendOffers 函数触发  desc信息  ：： ", session_desc);
                    pc.setLocalDescription(session_desc,function (){
                            console.log("  触发setLocalDescription  ==========  sucess");
                    },
                        function (error){
                            console.log("  触发setLocalDescription  ==========  error",error);
                        });
                    that.socket.send(JSON.stringify({
                        "eventName": "__offer",
                        "data": {
                            "sdp": session_desc,
                            "socketId": socketId
                        }
                    }));

                };
            },
            //
            pcCreateOfferErrorCb = function (error) {
                // console.log(error);
            };
        console.log("  触发sendOffers connections  ==========  ",this.connections);
        for (i = 0, m = this.connections.length; i < m; i++) {
            pc = this.peerConnections[this.connections[i]];
            pc.createOffer(pcCreateOfferCbGen(pc, this.connections[i]), pcCreateOfferErrorCb, setSdpConstraints(true));
        }
    };

    /**
     * 是否需要应答流（获取对方流）
     * @returns {*}
     */
    function setSdpConstraints(otr) {
        return !!navigator.mozGetUserMedia && parseFloat(getBrowserInfo().ver) > 34 ?
            {
                OfferToReceiveAudio: otr,
                OfferToReceiveVideo: otr
            } :
            {
                mandatory: {
                    OfferToReceiveAudio: otr,
                    OfferToReceiveVideo: otr
                }
            };
    }

    function getBrowserInfo() {
        var Sys = {};
        var ua = navigator.userAgent.toLowerCase();
        var re = /(msie|firefox|chrome|opera|version).*?([\d.]+)/;
        var m = ua.match(re);
        Sys.browser = m[1].replace(/version/, "'safari");
        Sys.ver = m[2];
        return Sys;
    }

    //接收到Offer类型信令后作为回应返回answer类型信令
    new_webrtc.prototype.receiveOffer = function (socketId, sdp) {
        console.log("=====  触发receiveOffer  ====>");
        var pc = this.peerConnections[socketId];
        try {
            this.sendAnswer(socketId, sdp);
        } catch (e) {
        }
    };

    //发送answer类型信令
    new_webrtc.prototype.sendAnswer = function (socketId, data) {
        console.log("触发  sendAnswer =============== ");
        var pc = this.peerConnections[socketId];
        var that = this;
        console.log("sendAnswer   sdp::::", data);
        if (data.sdp.indexOf('\na=extmap-allow-mixed') !== -1) {
            let sdp = data.sdp.split('\n').filter((line) => {
                return line.trim() !== 'a=extmap-allow-mixed';
            }).join('\n');
            data.sdp = sdp;
        }
        console.log("===============修改后的sdp ：：： ", data.sdp);
        pc.setRemoteDescription(new nativeRTCSessionDescription(data), function () {
            console.log(" ============ setRemoteDescription success ");
        }, function (err) {
            console.log(" ============ setRemoteDescription error ");
            throw new Error(err);
        });
        pc.createAnswer().then((session_desc) => {
            console.log("sendAnswer   session_desc::::", session_desc);
            pc.setLocalDescription(session_desc,
                function (){
                    console.log("sendAnswer  setLocalDescription ============== success", );
                }
            ,function (error){
                    console.log("sendAnswer  setLocalDescription  ==============  error", error);
                }
            );
            console.log("===== 发送__answer   ==== > SkyRTC");
            that.socket.send(JSON.stringify({
                "eventName": "__answer",
                "data": {
                    "socketId": socketId,
                    "sdp": session_desc
                }
            }));
        }).catch(error => {
            console.log("  createAnswer  error ===>", error);
        });

    };

    //接收到answer类型信令后将对方的session描述写入PeerConnection中
    new_webrtc.prototype.receiveAnswer = function (socketId, sdp) {
        console.log("===== 触发receiveAnswer start ====");
        var pc = this.peerConnections[socketId];
        var that = this;
        pc.setRemoteDescription(new nativeRTCSessionDescription(sdp),
            function () {
                console.log("接收到answer 触发setRemoteDescription ======= success");
            },
            function (err) {
                console.log("接收到answer 触发setRemoteDescription ======= error", err);
            });
        console.log("===== 触发receiveAnswer end ====");

    };


    /***********************点对点连接部分*****************************/


    //创建与其他用户连接的PeerConnections
    new_webrtc.prototype.createPeerConnections = function () {
        console.log(" ================= 触发createPeerConnections start ==================");
        console.log(constants.tempConnections);
        Object.keys(constants.tempConnections).forEach((socketId) => {
            this.createPeerConnection(socketId);
            this.connectionMap[socketId] = constants.tempConnections[socketId];
            this.connections.push(socketId)
        })
        console.log(" ================= 触发createPeerConnections end ==================");
    };

    //创建单个PeerConnection
    new_webrtc.prototype.createPeerConnection = function (socketId) {
        console.log("===== 创建连接 =================== createPeerConnection start");
        var that = this;
        var pc = new PeerConnection(iceServer);
        this.peerConnections[socketId] = pc;
        //将自己的sdp添加  到一个PC里
        pc.onicecandidate = function (evt) {
            console.log(" ========= 触发onicecandidate  start ===", evt);
            if (evt.candidate)
                that.socket.send(JSON.stringify({
                    "eventName": "__ice_candidate",
                    "data": {
                        "id": evt.candidate.sdpMid,
                        "label": evt.candidate.sdpMLineIndex,
                        "candidate": evt.candidate.candidate,
                        "socketId": socketId
                    }
                }));
            console.log(" ========= 触发onicecandidate  end ===");
            that.emit("pc_get_ice_candidate", evt.candidate, socketId, pc);
            console.log(util.context);
            util.context.videoShowLoading = false;
        };
        pc.onopen = function (evt) {
            that.emit("pc_opened", socketId, pc);
        };
        pc.onaddstream = function (evt) {
            console.log(" ==== 触发 onaddstream  回调 ====== ", evt);
            that.emit('pc_add_stream', evt.stream, socketId, pc);
            that.getStreamSettings(socketId);
        };
        //
        // pc.ontrack = function (evt) {
        //     console.log(" ==== 触发 ontrack  回调 ====== ",evt);
        //     that.emit('pc_add_stream', evt.stream, socketId, pc);
        //     that.getStreamSettings(socketId);
        // };

        pc.ondatachannel = function (evt) {
            that.addDataChannel(socketId, evt.channel);
            that.emit('pc_add_data_channel', evt.channel, socketId, pc);
        };
        return pc;
    };

    //关闭PeerConnection连接

    new_webrtc.prototype.closePeerConnection = function (pc) {
        if (!pc) return;
        pc.close();
    };

    /***********************数据通道连接部分*****************************/
    new_webrtc.prototype.getStreamSettings = function (socketId) {
        if (this.dataChannels[socketId]) this.dataChannels[socketId].send(JSON.stringify({
            type: "__get_stream_settings"
        }));
    }

    //消息广播
    new_webrtc.prototype.broadcast = function (message) {
        var socketId;
        for (socketId in this.dataChannels) {
            this.sendMessage(message, socketId, 'broadcast');
        }
    };

    //发送消息方法
    new_webrtc.prototype.sendMessage = function (message, socketId, action) {
        if (this.dataChannels[socketId].readyState.toLowerCase() === 'open') {
            this.dataChannels[socketId].send(JSON.stringify({
                type: "__message",
                action: action,
                data: message
            }));
        }
    };

    //对所有的PeerConnections创建Data channel
    new_webrtc.prototype.addDataChannels = function () {
        var connection;
        for (connection in this.peerConnections) {
            // if (this.connectionMap[connection].startsWith('terminal'))
            this.createDataChannel(connection);
        }
    };

    //对某一个PeerConnection创建Data channel
    new_webrtc.prototype.createDataChannel = function (socketId, lable) {

        var pc, key, channel;
        pc = this.peerConnections[socketId];
        if (!socketId) {
            this.emit("data_channel_create_error", socketId, new Error("attempt to create data channel without socket id"));
        }
        if (!(pc instanceof PeerConnection)) {
            this.emit("data_channel_create_error", socketId, new Error("attempt to create data channel without peerConnection"));
        }
        lable = lable || 'rtc-data'
        try {
            channel = pc.createDataChannel(lable);
        } catch (error) {
            this.emit("data_channel_create_error", socketId, error);
        }
        return this.addDataChannel(socketId, channel);
    };

    //为Data channel绑定相应的事件回调函数
    new_webrtc.prototype.addDataChannel = function (socketId, channel) {
        var that = this;
        channel.onopen = function () {
            that.dataChannels[socketId] = channel;
            that.emit('data_channel_opened', channel, socketId);
        };

        channel.onclose = function (event, err) {
            if (that.connections.length > 0 && that.connectionMap[socketId].split("|")[0].startsWith("terminal_")) {
                if (!that.dataChannels[socketId] && util.context.$route.matched[1].instances.default.ifShowHistoryMonitor) {
                    util.context.$Modal.info({
                        content: '当前电梯终端正在与其他用户连接，请稍候重试',
                        onOk: () => {
                            if (util.context.$route.name === 'page_lift_monitor') {
                                util.context.$route.matched[1].instances.default.ifShowHistoryMonitor = false;
                                if (util.context.$route.matched[1].instances.default.monitorType === '1') {
                                    that.socket.close();
                                }
                            }
                        }
                    })
                }

                let terminalId = that.connectionMap[socketId].split("|")[0].replace("terminal_", "")
                for (let room_id in that.room) {
                    if (that.room[room_id] == terminalId) {
                        if (util.context.$store.state.app.isOpenDownload) {
                            if (!util.context.$store.state.app.isCallHelp) {
                                util.context.$store.commit("changeDownloadState", false)
                                util.context.$Modal.error({
                                    title: '警告',
                                    content: "数据通道异常关闭，下载视频已停止",
                                    onOk: () => {
                                        util.page_monitor.checkedNum = 0
                                        util.page_monitor.files = []
                                        util.page_monitor.temFileDta = []
                                        util.page_monitor.ifShowHistoryMonitor = false
                                        util.page_monitor.monitorType = 1
                                        that.socket.close();
                                    },
                                    okText: '确定',
                                })
                            }
                        }
                    }
                }

            }
            delete that.dataChannels[socketId];
            that.emit('data_channel_closed', channel, socketId);
        };

        channel.onmessage = function (message) {
            var json;
            json = JSON.parse(message.data);
            if (json.type === '__file0') { // 字节数组方式（自定协议）
                that.onFileComing(json, socketId);
            } else if (json.type === '__stream_settings') {
                var videoTag = document.getElementById("other-" + socketId)
                if (videoTag) videoTag.style.transform = 'rotateZ(' + json.data.orientation + 'deg)';
            } else if (json.type === '__file') {
                /*that.receiveFileChunk(json);*/
                that.parseFilePacket(json, socketId);
            } else if (json.type === '__request') {
                that.onRequestBack(json);
            } else {
                that.emit('data_channel_message', channel, socketId, json);
            }
        };

        channel.onerror = function (err) {
            that.emit('data_channel_error', channel, socketId, err);
        };

        return channel;
    };


    /**********************************************************/
    /*                                                        */
    /*                       文件传输                         */
    /*                                                        */
    /**********************************************************/

    /************************公有部分************************/

    //解析Data channel上的文件类型包,来确定信令类型
    new_webrtc.prototype.parseFilePacket = function (json, socketId) {
        var signal = json.signal,
            that = this;
        if (signal === 'ask') {
            that.receiveFileAsk(json.sendId, json.name, json.size, socketId);
        } else if (signal === 'accept') {
            that.receiveFileAccept(json.sendId, socketId);
        } else if (signal === 'refuse') {
            that.receiveFileRefuse(json.sendId, socketId);
        } else if (signal === 'chunk') {
            that.receiveFileChunk(json.data, json.sendId, socketId, json.last, json.percent);
        } else if (signal === 'close') {
        }
    };

    /***********************发送者部分***********************/


    //通过Dtata channel向房间内所有其他用户广播文件
    new_webrtc.prototype.shareFile = function (dom) {
        var socketId,
            that = this;
        for (socketId in that.dataChannels) {
            that.sendFile(dom, socketId);
        }
    };

    //向某一单个用户发送文件
    new_webrtc.prototype.sendFile = function (dom, socketId) {
        var that = this,
            file,
            reader,
            fileToSend,
            sendId;
        if (typeof dom === 'string') {
            dom = document.getElementById(dom);
        }
        if (!dom) {
            that.emit("send_file_error", new Error("Can not find dom while sending file"), socketId);
            return;
        }
        if (!dom.files || !dom.files[0]) {
            that.emit("send_file_error", new Error("No file need to be sended"), socketId);
            return;
        }
        file = dom.files[0];
        that.fileChannels[socketId] = that.fileChannels[socketId] || {};
        sendId = that.getRandomString();
        fileToSend = {
            file: file,
            state: "ask"
        };
        that.fileChannels[socketId][sendId] = fileToSend;
        that.sendAsk(socketId, sendId, fileToSend);
        that.emit("send_file", sendId, socketId, file);
    };

    //发送多个文件的碎片
    new_webrtc.prototype.sendFileChunks = function () {
        var socketId,
            sendId,
            that = this,
            nextTick = false;
        for (socketId in that.fileChannels) {
            for (sendId in that.fileChannels[socketId]) {
                if (that.fileChannels[socketId][sendId].state === "send") {
                    nextTick = true;
                    that.sendFileChunk(socketId, sendId);
                }
            }
        }
        if (nextTick) {
            setTimeout(function () {
                that.sendFileChunks();
            }, 10);
        }
    };

    //发送某个文件的碎片
    new_webrtc.prototype.sendFileChunk = function (socketId, sendId) {
        var that = this,
            fileToSend = that.fileChannels[socketId][sendId],
            packet = {
                type: "__file",
                signal: "chunk",
                sendId: sendId
            },
            channel;

        fileToSend.sendedPackets++;
        fileToSend.packetsToSend--;


        if (fileToSend.fileData.length > packetSize) {
            packet.last = false;
            packet.data = fileToSend.fileData.slice(0, packetSize);
            packet.percent = fileToSend.sendedPackets / fileToSend.allPackets * 100;
            that.emit("send_file_chunk", sendId, socketId, fileToSend.sendedPackets / fileToSend.allPackets * 100, fileToSend.file);
        } else {
            packet.data = fileToSend.fileData;
            packet.last = true;
            fileToSend.state = "end";
            that.emit("sended_file", sendId, socketId, fileToSend.file);
            that.cleanSendFile(sendId, socketId);
        }

        channel = that.dataChannels[socketId];

        if (!channel) {
            that.emit("send_file_error", new Error("Channel has been destoried"), socketId, sendId, fileToSend.file);
            return;
        }
        channel.send(JSON.stringify(packet));
        fileToSend.fileData = fileToSend.fileData.slice(packet.data.length);
    };

    //发送文件请求后若对方同意接受,开始传输
    new_webrtc.prototype.receiveFileAccept = function (sendId, socketId) {
        var that = this,
            fileToSend,
            reader,
            initSending = function (event, text) {
                fileToSend.state = "send";
                fileToSend.fileData = event.target.result;
                fileToSend.sendedPackets = 0;
                fileToSend.packetsToSend = fileToSend.allPackets = parseInt(fileToSend.fileData.length / packetSize, 10);
                that.sendFileChunks();
            };
        fileToSend = that.fileChannels[socketId][sendId];
        reader = new window.FileReader(fileToSend.file);
        reader.readAsDataURL(fileToSend.file);
        reader.onload = initSending;
        that.emit("send_file_accepted", sendId, socketId, that.fileChannels[socketId][sendId].file);
    };

    //发送文件请求后若对方拒绝接受,清除掉本地的文件信息
    new_webrtc.prototype.receiveFileRefuse = function (sendId, socketId) {
        var that = this;
        that.fileChannels[socketId][sendId].state = "refused";
        that.emit("send_file_refused", sendId, socketId, that.fileChannels[socketId][sendId].file);
        that.cleanSendFile(sendId, socketId);
    };

    //清除发送文件缓存
    new_webrtc.prototype.cleanSendFile = function (sendId, socketId) {
        var that = this;
        delete that.fileChannels[socketId][sendId];
    };

    //发送文件请求
    new_webrtc.prototype.sendAsk = function (socketId, sendId, fileToSend) {
        var that = this,
            channel = that.dataChannels[socketId],
            packet;
        if (!channel) {
            that.emit("send_file_error", new Error("Channel has been closed"), socketId, sendId, fileToSend.file);
        }
        packet = {
            name: fileToSend.file.name,
            size: fileToSend.file.size,
            sendId: sendId,
            type: "__file",
            signal: "ask"
        };
        channel.send(JSON.stringify(packet));
    };

    //获得随机字符串来生成文件发送ID
    new_webrtc.prototype.getRandomString = function () {
        return (Math.random() * new Date().getTime()).toString(36).toUpperCase().replace(/\./g, '-');
    };

    /***********************接收者部分***********************/

    //接收到文件碎片
    new_webrtc.prototype.receiveFileChunk = function (data, sendId, socketId, last, percent) {
        var that = this,
            fileInfo = that.receiveFiles[sendId];
        let name = fileInfo.name
        let file = util.page_monitor.downloadPercent[name]
        file.percent = percent
        if (!fileInfo.data) {
            fileInfo.state = "receive";
            fileInfo.data = "";
        }
        fileInfo.data = fileInfo.data || "";
        fileInfo.data += data;
        if (last) {
            fileInfo.state = "end";
            that.getTransferedFile(sendId);
        } else {
            that.emit("receive_file_chunk", sendId, socketId, fileInfo.name, percent);
        }
    };

    //接收到所有文件碎片后将其组合成一个完整的文件并自动下载
    new_webrtc.prototype.getTransferedFile = function (sendId) {
        var that = this,
            fileInfo = that.receiveFiles[sendId],
            hyperlink = document.createElement("a"),
            mouseEvent = new MouseEvent('click', {
                view: window,
                bubbles: true,
                cancelable: true
            });
        saveAs(dataURItoBlob(fileInfo.data), fileInfo.name);
        that.emit("receive_file", sendId, fileInfo.socketId, fileInfo.name);
        that.cleanReceiveFile(sendId);
    };

    function dataURItoBlob(dataURI) {
        var byteString = atob(dataURI.split(',')[1]);
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], {type: mimeString});
    }

    //接收到发送文件请求后记录文件信息
    new_webrtc.prototype.receiveFileAsk = function (sendId, fileName, fileSize, socketId) {
        var that = this;
        that.receiveFiles[sendId] = {
            socketId: socketId,
            state: "ask",
            name: fileName,
            size: fileSize
        };
        that.emit("receive_file_ask", sendId, socketId, fileName, fileSize);
        that.sendFileAccept(sendId);
    };

    //发送同意接收文件信令
    new_webrtc.prototype.sendFileAccept = function (sendId) {
        var that = this,
            fileInfo = that.receiveFiles[sendId],
            channel = that.dataChannels[fileInfo.socketId],
            packet;
        if (!channel) {
            that.emit("receive_file_error", new Error("Channel has been destoried"), sendId, socketId);
        }
        packet = {
            type: "__file",
            signal: "accept",
            sendId: sendId
        };
        channel.send(JSON.stringify(packet));
    };

    //发送拒绝接受文件信令
    new_webrtc.prototype.sendFileRefuse = function (sendId) {
        var that = this,
            fileInfo = that.receiveFiles[sendId],
            channel = that.dataChannels[fileInfo.socketId],
            packet;
        if (!channel) {
            that.emit("receive_file_error", new Error("Channel has been destoried"), sendId, socketId);
        }
        packet = {
            type: "__file",
            signal: "refuse",
            sendId: sendId
        };
        channel.send(JSON.stringify(packet));
    };

    //清除接受文件缓存
    new_webrtc.prototype.cleanReceiveFile = function (sendId) {
        var that = this;
        delete that.receiveFiles[sendId];
    };
    new_webrtc.prototype.request = function ({action, dest, data, success, error, timeout}) {
        let socketId = this.me;
        let type = '__request';
        let requestId = this.getRandomString();
        this.channelRequestCallbacks[requestId] = success;

        if (!dest || !this.dataChannels[dest]) {
            if (error) error(new Error('cannot find datachannel of dest: ' + dest));
            return;
        }
        if (this.dataChannels[dest].readyState.toLowerCase() === 'open') {
            this.dataChannels[dest].send(JSON.stringify({
                action, type, dest, data, socketId, requestId
            }));
            if (error && timeout) {
                //超时 其他错误
                this.channelRequestTimers[requestId] = setTimeout(() => {
                    error(new Error('no response came back within ' + timeout + 'ms'))
                }, timeout)
            }
        } else {
            if (error) error(new Error('data channel for [' + dest + '] is closed'))
        }
    }
    new_webrtc.prototype.onRequestBack = function (msg) {
        if (this.channelRequestCallbacks[msg.requestId]) {
            clearTimeout(this.channelRequestTimers[msg.requestId])
            this.channelRequestCallbacks[msg.requestId](msg.data);
            delete this.channelRequestCallbacks[msg.requestId];
            delete this.channelRequestTimers[msg.requestId];
        } else {
            // console.info('==webRTC request 响应==>', msg)
        }
    }
    var filePool = {};
    new_webrtc.prototype.onFileComing = function (message, remoteSocketId) {
        let fileObj, that = this;
        switch (message.action) {
            case 'file_start':
                filePool[message.requestId] = {
                    filename: message.data.filename,
                    size: message.data.size,
                    buffer: []
                }
                break;
            case 'file_add':
                fileObj = filePool[message.requestId];
                var byteArr = [];
                var byteString = atob(message.data.buffer);
                for (var i = 0; i < byteString.length; i++) {
                    byteArr.push(byteString.charCodeAt(i));
                }
                fileObj.buffer[message.index] = byteArr;
                fileObj.leng = (fileObj.leng || 0) + byteArr.length;
                var percent = Math.round(fileObj.leng * 100 / fileObj.size);
                var fileVM = util.page_monitor.downloadPercent[fileObj.filename]
                fileVM.percent = percent;
                // console.log('file comes ====> ',message);
                that.request({
                    action: 'file_add_ack',
                    dest: remoteSocketId,
                    data: {
                        requestId: message.requestId,
                        index: message.index
                    }
                })
                break;
            case 'file_end':
                fileObj = filePool[message.requestId];
                var byteArr = [];
                fileObj.buffer.forEach(bytes => {
                    if (!bytes) return;
                    byteArr.push(...bytes)
                })
                var blob = new Blob([new Int8Array(byteArr)])
                that.number++;
                saveAs(blob, fileObj.filename);
                delete filePool[message.requestId];
                that.finishFileDownload(fileObj.filename);
                break;
        }
    }

    new_webrtc.prototype.finishFileDownload = function (filename) {
        var that = this
        that.fileFinish++;
        if (util.page_monitor.checkedNum == that.fileFinish) {
            util.context.$store.commit("changeDownloadState", false)
            that.fileFinish = 0;
            util.page_monitor.checkedNum = 0;
            util.context.$Notice.success({
                title: "提示",
                desc: '文件下载完成',
                duration: 1
            })
        }
        util.page_monitor.clearFinishDown(filename);
    }
    return new new_webrtc();

};

export default new_webrtc();
